import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "card-header border-0 pt-5" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "card-title align-items-start flex-column" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Recent Orders"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-muted mt-1 fw-bold fs-7" }, "Over 500 orders")
], -1)
const _hoisted_3 = { class: "card-toolbar" }
const _hoisted_4 = {
  type: "button",
  class: "btn btn-sm btn-icon btn-color-primary btn-active-light-primary",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = { class: "card-body py-3" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-25px" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
        /*#__PURE__*/_createElementVNode("input", {
          class: "form-check-input",
          type: "checkbox",
          value: "1",
          "data-kt-check": "true",
          "data-kt-check-target": ".widget-13-check"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Order Id"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "Country"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Date"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Company"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Total"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Status"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-end" }, "Actions")
  ])
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "form-check form-check-sm form-check-custom form-check-solid" }, [
    /*#__PURE__*/_createElementVNode("input", {
      class: "form-check-input widget-13-check",
      type: "checkbox",
      value: "1"
    })
  ])
], -1)
const _hoisted_11 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary fs-6"
}
const _hoisted_12 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_13 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_14 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_15 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_16 = {
  href: "#",
  class: "text-dark fw-bolder text-hover-primary d-block mb-1 fs-6"
}
const _hoisted_17 = { class: "text-muted fw-bold text-muted d-block fs-7" }
const _hoisted_18 = { class: "text-dark fw-bolder text-hover-primary fs-6" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
}
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1"
}
const _hoisted_23 = { class: "svg-icon svg-icon-3" }
const _hoisted_24 = {
  href: "#",
  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
}
const _hoisted_25 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown2 = _resolveComponent("Dropdown2")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, {
              src: "/media/icons/duotune/general/gen024.svg",
              "aria-hidden": "true"
            })
          ])
        ]),
        _createVNode(_component_Dropdown2)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("table", _hoisted_8, [
          _hoisted_9,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _hoisted_10,
                _createElementVNode("td", null, [
                  _createElementVNode("a", _hoisted_11, _toDisplayString(item.orderid), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("a", _hoisted_12, _toDisplayString(item.company.name), 1),
                  _createElementVNode("span", _hoisted_13, "Code: " + _toDisplayString(item.country.code), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("a", _hoisted_14, _toDisplayString(item.date.value), 1),
                  _createElementVNode("span", _hoisted_15, "Code: " + _toDisplayString(item.date.remarks), 1)
                ]),
                _createElementVNode("td", null, [
                  _createElementVNode("a", _hoisted_16, _toDisplayString(item.company.name), 1),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(item.company.fields), 1)
                ]),
                _createElementVNode("td", _hoisted_18, _toDisplayString(item.total), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass([`badge-light-${item.status.color}`, "badge"])
                  }, _toDisplayString(item.status.label), 3)
                ]),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("a", _hoisted_20, [
                    _createElementVNode("span", _hoisted_21, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen019.svg" })
                    ])
                  ]),
                  _createElementVNode("a", _hoisted_22, [
                    _createElementVNode("span", _hoisted_23, [
                      _createVNode(_component_inline_svg, {
                        src: "/media/icons/duotune/art/art005.svg",
                        "aria-hidden": "true"
                      })
                    ])
                  ]),
                  _createElementVNode("a", _hoisted_24, [
                    _createElementVNode("span", _hoisted_25, [
                      _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen027.svg" })
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}